import ErrorState from 'common/ErrorState/ErrorState';
import { useRevealGroup } from 'hooks/useReveal';
import { useContent } from 'hooks/useContent';
import Loader from 'components/Loader/Loader';
import Folder from './Folder/Folder';
import './DocumentsFolder.css';
import { useLanguage } from 'hooks/useLanguage';

/**
 * Документи: розділи — ADR-0004.
 *
 * Прибрано тривимірні жовті теки з аркушами всередині й ярликом «Docs»,
 * намальовані на CSS-трансформаціях. Розділ документів офіційної організації
 * має виглядати як покажчик, а не як ілюстрація тек.
 *
 * Документи й розділи вантажаться одним станом: показувати перелік розділів
 * без кількостей у них немає сенсу, тому й кнопка повтору тут одна.
 */
export default function DocumentsFolder() {
  const language = useLanguage();
  const { data, status, error, retry, isLoading } = useContent('documents');
  const gridRef = useRevealGroup('.folder-wrapper', { step: 45 }, status);

  const { list: documents, types } = data;

  function countFor(typeId) {
    return documents.filter((document) => document.documentType?.id === typeId).length;
  }

  return (
    <div className='folders-wrapper section'>
      <div className='container'>
        <header className='documents-head'>
          <h1 className='page-title'>{language === 'en' ? 'Documents' : 'Документи'}</h1>
          <p className='lede'>
            {language === 'en'
              ? 'Official documents of the organization, grouped by category.'
              : 'Офіційні документи організації, згруповані за розділами.'}
          </p>
        </header>

        {isLoading && <Loader />}

        {status === 'failed' && <ErrorState error={error} onRetry={retry} />}

        {status === 'succeeded' &&
          (types.length > 0 ? (
            <div className='folders' ref={gridRef}>
              {types.map((type) => (
                <Folder type={type} typeId={type.id} count={countFor(type.id)} key={type.id} />
              ))}
            </div>
          ) : (
            <p className='empty-note'>
              {language === 'en' ? 'There are no documents yet.' : 'Документів поки немає.'}
            </p>
          ))}
      </div>
    </div>
  );
}
